// extracted by mini-css-extract-plugin
export default {"title":"ProjectMap_title__fL5kd","map":"ProjectMap_map__i6CGq","width":"ProjectMap_width__3sPfA"};